import { defineVariants } from "@/runtime/style-engine/define-variants";

/**
 * Tailwind-like class variants for `<e-heading>`.
 */
export const headingClasses = defineVariants({
  base: `
    flex
    items-center
    gap-2
    font-heading
    lowercase
    font-semibold
  `,
  variants: {
    color: {
      primary: `text-(--color-primary)`,
      secondary: `text-(--color-secondary)`,
      accent: `text-(--color-accent)`,
      error: `text-(--color-error)`,
      warning: `text-(--color-warning)`,
      info: `text-(--color-info)`,
      success: `text-(--color-success)`,
      neutral: `text-(--color-foreground)`,
      mono: `text-(--color-background)!`,
    },

    size: {
      xs: `text-base`,
      sm: `text-lg`,
      md: `text-xl`,
      lg: `text-2xl`,
      xl: `text-3xl`,
      "2xl": `text-4xl`,
    },
  },

  defaults: {
    size: "md",
  },
});
